// extracted by mini-css-extract-plugin
module.exports = {"item":"suppliersListItemSkeleton_item__1yfSn","row":"suppliersListItemSkeleton_row__1Kd6U"};